import React, { useEffect, useRef } from 'react';
import { useVacancyStore } from '../../store/vacancyStore';
import { PositionStatusEnum } from '../../../generated-src/client/positions/api';
import { getPositionStatusDotClass } from '../../utils/vacancyStatus';
import { useRoleAccess } from '../../hooks/useRoleAccess';

export function SidebarFilters() {
  const {
    filterTab,
    selectedStatusFilter,
    statusDropdownOpen,
    setFilterTab,
    setStatusFilter,
    toggleStatusDropdown,
    setStatusDropdownOpen,
  } = useVacancyStore();
  const { isRecruiter } = useRoleAccess();

  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setStatusDropdownOpen(false);
      }
    }

    if (statusDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [statusDropdownOpen, setStatusDropdownOpen]);

  const getFilterLabel = () => {
    if (filterTab === 'all') return 'общие';
    return 'мои';
  };

  const getStatusLabel = () => {
    if (selectedStatusFilter === 'all') return 'все статусы';
    if (selectedStatusFilter === PositionStatusEnum.ACTIVE) return 'активные';
    if (selectedStatusFilter === PositionStatusEnum.PAUSED) return 'на паузе';
    if (selectedStatusFilter === PositionStatusEnum.ARCHIVED) return 'в архиве';
    return 'все статусы';
  };

  return (
    <div className="px-5 pb-3 pt-0 flex items-center gap-2 text-[13px] text-[var(--text-medium)]">
      <span className="font-medium">Вакансии</span>
      {!isRecruiter && (
        <button
          className="flex items-center gap-1 hover:text-[var(--text-dark)] font-medium ml-auto transition-colors"
          onClick={() => setFilterTab(filterTab === 'all' ? 'my' : 'all')}
        >
          {getFilterLabel()}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M3 5L6 8L9 5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}

      <div className="relative" ref={dropdownRef}>
        <button
          className="flex items-center gap-1 hover:text-[var(--text-dark)] font-medium transition-colors"
          onClick={toggleStatusDropdown}
        >
          {getStatusLabel()}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={`transition-transform ${statusDropdownOpen ? 'rotate-180' : ''}`}>
            <path d="M3 5L6 8L9 5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {statusDropdownOpen && (
          <div className="absolute top-full right-0 mt-2 min-w-[150px] bg-white rounded-lg border border-sidebar-border shadow-lg z-50 py-1">
            <button
              onClick={() => setStatusFilter('all')}
              className={`w-full text-left px-3 py-2 text-[13px] font-medium hover:bg-[#F5F6F1] transition-colors ${
                selectedStatusFilter === 'all' ? 'text-[var(--brand-primary)]' : 'text-[var(--text-medium)]'
              }`}
            >
              Все статусы
            </button>
            <button
              onClick={() => setStatusFilter(PositionStatusEnum.ACTIVE)}
              className={`w-full flex items-center gap-2 text-left px-3 py-2 text-[13px] font-medium hover:bg-[#F5F6F1] transition-colors ${
                selectedStatusFilter === PositionStatusEnum.ACTIVE ? 'text-[var(--brand-primary)]' : 'text-[var(--text-medium)]'
              }`}
            >
              <span className={`w-2 h-2 rounded-full flex-shrink-0 ${getPositionStatusDotClass(PositionStatusEnum.ACTIVE)}`} />
              Активные
            </button>
            <button
              onClick={() => setStatusFilter(PositionStatusEnum.PAUSED)}
              className={`w-full flex items-center gap-2 text-left px-3 py-2 text-[13px] font-medium hover:bg-[#F5F6F1] transition-colors ${
                selectedStatusFilter === PositionStatusEnum.PAUSED ? 'text-[var(--brand-primary)]' : 'text-[var(--text-medium)]'
              }`}
            >
              <span className={`w-2 h-2 rounded-full flex-shrink-0 ${getPositionStatusDotClass(PositionStatusEnum.PAUSED)}`} />
              На паузе
            </button>
            <button
              onClick={() => setStatusFilter(PositionStatusEnum.ARCHIVED)}
              className={`w-full flex items-center gap-2 text-left px-3 py-2 text-[13px] font-medium hover:bg-[#F5F6F1] transition-colors ${
                selectedStatusFilter === PositionStatusEnum.ARCHIVED ? 'text-[var(--brand-primary)]' : 'text-[var(--text-medium)]'
              }`}
            >
              <span className={`w-2 h-2 rounded-full flex-shrink-0 ${getPositionStatusDotClass(PositionStatusEnum.ARCHIVED)}`} />
              В архиве
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
